import React from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import NProgress from 'nprogress';
import { Helmet } from 'react-helmet';
import Loader from "../components/layout/Loader/Loader";
import compose from 'recompose/compose';
import PublicLayout from "./Public";
import AppLayout from "./App";
import AuthLayout from "./Auth";
import {ReducerType} from "../redux/reducer.type";
import { LayoutPropsType, LayoutsPrevPropsType } from "./layout.type";
import { titlePrefix, titleDefult } from "../config/config";
import userActions from "../redux/user/actions";
import { withTranslation } from 'react-i18next';
import { history } from "../index";
import {
    ROUTE_ACTIVE_WORKSPACES_DETAILS,
    ROUTE_DEVICES,
    ROUTE_DEVICES_DETAILS,
    ROUTE_DRIVERS,
    ROUTE_DRIVERS_DETAILS, ROUTE_INVOICE,
    ROUTE_LOGIN,
    ROUTE_POI,
    ROUTE_ROUTE_REPORT,
    ROUTE_ROUTES,
    ROUTE_STATISTICS,
    ROUTE_TELEMETRY,
    ROUTE_VEHICLES,
    ROUTE_VEHICLES_DETAILS,
    ROUTE_WORKSPACE_BLOCKED,
    ROUTE_WORKSPACES_LIST
} from "../config/routes";
import {isSuperAdmin, validateSessionStorage} from "../utils/utils";

const Layouts = {
    public: PublicLayout,
    auth: AuthLayout,
    app: AppLayout,
};

class Layout extends React.Component<LayoutPropsType, any> {
    previousPath = '';

    componentDidMount(): void {
        const {
            dispatch,
            location: { pathname },
        } = this.props;
        if (sessionStorage.getItem('access_token')) {
            dispatch({
                type: userActions.LOAD_CURRENT_ACCOUNT
            });
        }
        if (pathname === '/' && sessionStorage.getItem('access_token')) {
            history.push(ROUTE_TELEMETRY);
        } else if (pathname === '/' && !sessionStorage.getItem('access_token')) {
            history.push(ROUTE_LOGIN);
        }
    }
    componentDidUpdate(prevProps: Readonly<LayoutsPrevPropsType>, prevState: Readonly<{}>, snapshot?: any): void {
        const { location, user, dispatch, location: { pathname } } = this.props;
        // onRefresh
        if(!this.props.user.activeWorkspace) {

        } else {
            if (!isSuperAdmin() &&
                !this.props.location.pathname.includes("/auth/") &&
                // (this.props.location.pathname !== ROUTE_ACTIVE_WORKSPACES_DETAILS) &&
                (prevProps.user.activeWorkspace !== this.props.user.activeWorkspace) &&
                this.props.user.activeWorkspace.is_blocked ) {
                if(Number(this.props.user.activeWorkspace.is_blocked) === 1) {
                    history.push(ROUTE_WORKSPACE_BLOCKED)
                } else if(Number(this.props.user.activeWorkspace.is_blocked) === 2 && this.props.user.activeWorkspace.customer_type === "S" && (user.uuid === user.activeWorkspace.owner?.uuid)) {
                    if(this.props.location.pathname.includes("/invoices/details/")) {} else {
                        history.push(ROUTE_INVOICE)
                    }
                } else {
                    history.push(ROUTE_WORKSPACE_BLOCKED)
                }
            }
            // onChange
            if (!isSuperAdmin() &&
                (prevProps.location.pathname !== this.props.location.pathname) &&
                !this.props.location.pathname.includes("/auth/") &&
                // (this.props.location.pathname !== ROUTE_ACTIVE_WORKSPACES_DETAILS ) &&
                this.props.user.activeWorkspace.is_blocked ) {
                if(Number(this.props.user.activeWorkspace.is_blocked) === 1) {
                    history.push(ROUTE_WORKSPACE_BLOCKED)
                } else if(Number(this.props.user.activeWorkspace.is_blocked) === 2 && this.props.user.activeWorkspace.customer_type === "S" && (user.uuid === user.activeWorkspace.owner?.uuid)) {
                    if(this.props.location.pathname.includes("/invoices/details/")) {} else {
                        history.push(ROUTE_INVOICE)
                    }
                } else {
                    history.push(ROUTE_WORKSPACE_BLOCKED)
                }
            }
        }


        if(isSuperAdmin() && !validateSessionStorage("superAdminWorkspace")){
            if (pathname === ROUTE_TELEMETRY ||
                pathname === ROUTE_STATISTICS ||
                pathname === ROUTE_ROUTES ||
                pathname === ROUTE_ROUTE_REPORT ||
                pathname === ROUTE_DEVICES ||
                pathname === ROUTE_DEVICES_DETAILS() ||
                pathname === ROUTE_VEHICLES ||
                pathname === ROUTE_VEHICLES_DETAILS() ||
                pathname === ROUTE_DRIVERS ||
                pathname === ROUTE_DRIVERS_DETAILS() ||
                pathname === ROUTE_POI ||
                pathname === ROUTE_ACTIVE_WORKSPACES_DETAILS
                // pathname === ROUTE_COUNTRY_LIST ||
                // pathname === ROUTE_ADDRESS_TYPE_LIST ||
                // pathname === ROUTE_ADDRESS_TYPE_CREATE ||
                // pathname === ROUTE_CONTACT_TYPE_LIST ||
                // pathname === ROUTE_CONSENTS ||
                // pathname === ROUTE_CONSENT_CREATE ||
                // pathname === ROUTE_CONSENT_EDIT()
            ){
                history.push(ROUTE_WORKSPACES_LIST)
            }
        }

        const { prevLocation } = prevProps;
        if (location !== prevLocation) {
            window.scrollTo(0, 0)
        }
        if (!user.authorized && !user.loading && !(/^\/auth(?=\/|$)/i.test(pathname))) {
            if (sessionStorage.getItem("access_token") || localStorage.getItem("access_token")) {
                return;
            } else {
                console.log("src/layouts/index - LOGOUT - CHECK - POSSIBLY ISSUES");
                dispatch({
                    type: userActions.LOGOUT,
                    payload: this.props.location.pathname
                });
            }
        }
    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        const {
            children,
            location: { pathname, search },
            user,
            t,
        } = this.props;

        // NProgress Management
        const currentPath = pathname + search;
        if (currentPath !== this.previousPath) {
            NProgress.start()
        }

        setTimeout(() => {
            NProgress.done();
            this.previousPath = currentPath;
        }, 300);

        // Layout Rendering
        const getLayout = () => {
            if (pathname === '/') {
                return 'public'
            }
            if (/^\/auth(?=\/|$)/i.test(pathname)) {
                return 'auth'
            }
            return 'app'
        };

        const Container: any = Layouts[getLayout()];
        const isUserAuthorized = user.authorized;
        const isUserLoading = user.loading;
        const isAuthLayout = getLayout() === 'auth';

        const BootstrappedLayout = () => {
            // show loader when user in check authorization process, not authorized yet and not on login pages
            if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
                return <Loader spinning={true} fullScreen={true} />
            }
            // in other case render previously set layout
            return <Container>{children}</Container>
        };

        return (
            <>
                <Helmet titleTemplate={`${t(titlePrefix)} | %s`} title={t(titleDefult)} />
                {BootstrappedLayout()}
            </>
        );
    }
}

const mapStateToProps = (state: ReducerType) => {
    // console.log({config: state.customerConfiguration, activeWorkspace: state.user.activeWorkspace && state.user.activeWorkspace.uuid})
    return ({ user: state.user })
};

export default withRouter(compose<LayoutPropsType, any>(
    connect(mapStateToProps),
    withTranslation('template')
)(Layout)) as React.ComponentClass<{}>;
